"use strict";
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(exports.NavigationEvent || (exports.NavigationEvent = {}));
var NavigationEvent = exports.NavigationEvent;
//# sourceMappingURL=datepicker-view-model.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/datepicker/datepicker-view-model.js
// module id = 53
// module chunks = 0